import { l as r } from "../../lookUpByPath-D0L99z-9.js";
const n = () => (t) => r(t, "theme"), s = (t) => (e) => r(n()(e), `palette.${t}`), u = (t) => (e) => r(n()(e), `palette.text.${t}`), l = (t) => (e) => r(n()(e), `palette.background.${t}`), d = (t) => (e) => r(n()(e), `palette.foreground.${t}`), i = (t) => (e) => r(n()(e), `palette.border.${t}`), p = (t) => (e) => r(s("colors")(e), t), $ = (t) => (e) => r(s("base")(e), t), P = (t) => (e) => r(n()(e), `spacings.${t}`), m = (t) => (e) => r(n()(e), `widths.${t}`), f = (t) => (e) => r(n()(e), `radii.${t}`), h = (t) => (e) => r(n()(e), `effects.${t}`), k = (t) => (e) => r(n()(e), `zIndexes.${t}`), c = (t, e) => (o) => {
  const a = r(n()(o), `breakpoints.${e}`);
  return `(${t}-width: ${a})`;
}, B = (t, e) => (o) => `@media ${c(t, e)(o)}`, x = (t) => (e) => r(n()(e), `components.${t}`);
export {
  c as getBreakpoint,
  B as getBreakpointMediaQuery,
  x as getComponents,
  h as getEffects,
  s as getPalette,
  l as getPaletteBackground,
  $ as getPaletteBase,
  i as getPaletteBorder,
  p as getPaletteColors,
  d as getPaletteForeground,
  u as getPaletteText,
  f as getRadii,
  P as getSpacings,
  n as getTheme,
  m as getWidths,
  k as getZIndexes
};
